import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuth } from '@/modules/auth'
import { ExternalLink } from '@/ui/icons'
import { Button } from '@/ui/components/'
import { Card, CardContent, CardHeader, CardTitle } from '@/ui/components/'
import { PageLayout } from '@/ui/layout'
import { PageMeta } from '@/components/PageMeta'

const DEPRECATED_NOTICE_KEY = 'sitrepp.join.invite_code_deprecated'

export default function JoinTrip() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()
  const [showDeprecatedNotice, setShowDeprecatedNotice] = useState(false)

  useEffect(() => {
    const code = searchParams.get('code')
    if (code) {
      sessionStorage.setItem(DEPRECATED_NOTICE_KEY, '1')
      navigate('/join', { replace: true })
      return
    }
    if (sessionStorage.getItem(DEPRECATED_NOTICE_KEY) === '1') {
      sessionStorage.removeItem(DEPRECATED_NOTICE_KEY)
      setShowDeprecatedNotice(true)
    }
  }, [searchParams, navigate])

  return (
    <>
      <PageMeta
        title="Join a trip"
        description="Use the share link your organizer sends you to join an overlanding trip on SitRepp.io."
      />
      <PageLayout showHeader={true}>
        <div className="min-h-screen bg-earth-50 py-8 px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto flex flex-col gap-8">
            <div className="text-center">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-3 sm:mb-4 tracking-tight">
                Join a trip
              </h1>
              <p className="text-base sm:text-lg text-muted-foreground max-w-xl mx-auto">
                Trips are invite-only. Use the link your organizer sends you—open it in your browser or tap it from
                email or messages.
              </p>
            </div>

            {showDeprecatedNotice && (
              <div
                role="status"
                className="rounded-lg border border-warning/30 bg-warning/10 px-4 py-3 text-sm text-foreground"
              >
                Invite codes are no longer supported. Ask your organizer for a SitRepp share link to join this trip.
              </div>
            )}

            <Card className="shadow-lg border-earth-200 text-left">
              <CardHeader className="pb-2">
                <CardTitle className="text-xl sm:text-2xl flex items-center gap-2">
                  <ExternalLink className="h-6 w-6 text-adventure-600 shrink-0" aria-hidden />
                  Share links
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3 text-sm text-muted-foreground leading-relaxed">
                <p>
                  The link will look like{' '}
                  <span className="font-medium text-foreground/90">/share/</span> followed by a trip ID. Open it
                  in your browser’s address bar or tap it from a message—the same way you would open any other link.
                </p>
              </CardContent>
            </Card>

            <div className="text-center pt-2">
              <Button
                variant="ghost"
                onClick={() => navigate(isAuthenticated ? '/dashboard' : '/')}
                className="text-muted-foreground hover:text-foreground"
              >
                Back to home
              </Button>
            </div>
          </div>
        </div>
      </PageLayout>
    </>
  )
}
